import { Pipe, PipeTransform } from '@angular/core';
import { GoverningJurisdictionTypeId } from '../../../models/enum/shared/governing-jurisdiction-type-id';
import { GOVERNING_JURISDICTION_NAMES } from '../../../consts/consts';

@Pipe({
  name: 'governingJurisdictionName',
  standalone: true
})
export class GoverningJurisdictionNamePipe implements PipeTransform {
  transform(jurisdictionId: GoverningJurisdictionTypeId | null | undefined): string {
    return jurisdictionId ? GOVERNING_JURISDICTION_NAMES[jurisdictionId] : '';
  }
}
